import React from 'react';

const Title = ({ className, title, children }) => {
    return <h1 className={"title-font sm:text-4xl text-3xl m-3 md:ml-0 font-medium text-white " + className}>
        {title || children} 
    </h1>
};

export default Title;